(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/casino-game-list/assets/javascripts/casino-gamelist.js') >= 0) return;  svs.modules.push('/widgets/casino-game-list/assets/javascripts/casino-gamelist.js'); "use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function () {
  'use strict';

  document.cookie = 'referrercategory=; path=/casino/; Max-Age=-1;';

  var trackClick = function trackClick() {
    var el;

    if (this.classList.contains('js-widget-casino-game-list-link')) {
      el = this;
    } else {
      el = $(this).parents('.js-widget-casino-game-list-link-wrap')[0];
    }

    if (el) {
      var name = el.dataset.name;
      svs.components.analytics.trackPromoClick({
        id: name,
        name: name,
        position: el.dataset.position,
        opt_label: 'Casino'
      });
    }
  };

  if (svs.core.detect.formfactor.desktop()) {
    $(document).on('click', '.js-widget-casino-game-list .js-casino-track-click', trackClick);
  } else {
    $(document).on('click', '.js-widget-casino-game-list-link', trackClick);
  }

  var GameUpdater = function () {
    function GameUpdater(el) {
      var _this = this;

      _classCallCheck(this, GameUpdater);

      this.el = el;

      if (window.IntersectionObserver) {
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting === true || e.intersectionRatio > 0) {
              _this.subscribe();

              _this.observer.unobserve(_this.el);
            }
          });
        }, {
          rootMargin: '0px 0px 250px 0px'
        });
        this.observer.observe(this.el);
      } else {
        this.subscribe();
      }
    }

    _createClass(GameUpdater, [{
      key: "subscribe",
      value: function subscribe() {
        $(this.el).find('.js-widget-casino-item-jackpot').each(function (i, el) {
          new svs.widget.casino_game_list.JackpotUpdater($(el));
        });
        $(this.el).find('.js-widget-casino-item-liveinfo').each(function (i, el) {
          new svs.widget.casino_game_list.LiveGameUpdater($(el));
        });
      }
    }]);

    return GameUpdater;
  }();

  new GameUpdater($('.js-widget-casino-game-list')[0]);
})();
 })(window);